import React, {useEffect, useState} from "react";
import "../../styles/PaintFolder.css";
import icon from "../../assets/images/paint.webp";
import Draggable from "react-draggable";

const PaintFolder = ({ name, onClick }) => {
    const [isDesktop, setIsDesktop] = useState(true);
        const [clickCount, setClickCount] = useState(0);
    
        useEffect(() => {
            const checkDevice = () => {
                setIsDesktop(!("ontouchstart" in window || navigator.maxTouchPoints > 0));
            };
            checkDevice();
            window.addEventListener("resize", checkDevice);
            return () => window.removeEventListener("resize", checkDevice);
        }, []);
    
        const handleClick = () => {
            setClickCount((prevCount) => prevCount + 1);
    
            setTimeout(() => {
                setClickCount(0);
            }, 300);
            if (clickCount === 1) {
                onClick();
            }
        };
    return isDesktop ?(
        <Draggable>
        <div className="paint">
            <div onClick={handleClick}>
            <img src={icon} alt="paint icon"/>
            <span>{name}</span>
            </div>
        </div>
        </Draggable>
    ) : (
        <div className="paint" onClick={onClick}>
            <img src={icon} alt="paint icon"/>
            <span>{name}</span>
        </div>
    );
};

export default PaintFolder;